import { Button } from "@/components/ui/button";
import {
	Drawer,
	DrawerContent,
	DrawerHeader,
	DrawerTitle,
	DrawerTrigger,
} from "@/components/ui/drawer";
import {
	Sheet,
	SheetContent,
	SheetHeader,
	SheetTitle,
	SheetTrigger,
} from "@/components/ui/sheet";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { MessageSquare } from "lucide-react";
import { useGetUserMessagesQuery } from "../api/getUserMessages";
import { MessageHistory } from "./MessageHistory";

interface Props {
	patientId: string;
}

export function MessageHistorySheet({ patientId }: Props) {
	const isDesktop = useMediaQuery("(min-width: 768px)");
	const { data, isLoading } = useGetUserMessagesQuery(patientId);

	const trigger = (
		<Button variant="ghost" size="icon">
			<MessageSquare className="w-5 h-5" />
			<span className="sr-only">View Messages</span>
		</Button>
	);

	const content = (
		<>
			<div className="px-2 py-6">
				<MessageHistory messages={data?.items ?? []} isLoading={isLoading} />
			</div>
		</>
	);

	if (isDesktop) {
		return (
			<Sheet>
				<SheetTrigger asChild>{trigger}</SheetTrigger>
				<SheetContent className="">
					<SheetHeader>
						<SheetTitle>Message History</SheetTitle>
					</SheetHeader>
					{content}
				</SheetContent>
			</Sheet>
		);
	}

	return (
		<Drawer>
			<DrawerTrigger asChild>{trigger}</DrawerTrigger>
			<DrawerContent className="mb-4 pb-4 max-h-[70svh]">
				<DrawerHeader>
					<DrawerTitle>Message History</DrawerTitle>
				</DrawerHeader>
				{content}
			</DrawerContent>
		</Drawer>
	);
}
